<template>
  <div style="padding: 20px">
    <div style="margin-bottom: 20px">
      <select-area @areaListId="getAreaListId"/>
      <el-input v-model="query.coachName" style="width: 180px;margin-right: 10px" placeholder="姓名" />
      <el-date-picker
          v-model="query.changeDate"
          type="daterange"
          placeholder="请选择"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
      />
      <el-button type="primary" style="margin-left: 10px" @click="selectPageList">搜索</el-button>
    </div>
    <el-table
        :data="tableData.pageList.records" class="table" height="626px" border v-loading="query.loading">
      <el-table-column prop="coachId" label="ID" width="100"/>
      <el-table-column prop="coachName" label="姓名" width="120"/>
      <el-table-column prop="directorName" label="城市校区" width="300">
        <template #default="scope">
          {{scope.row.areaCity}}-{{scope.row.areaRegion}}-{{scope.row.areaName}}-{{scope.row.areaFlag}}
        </template>
      </el-table-column>
      <el-table-column align="center" v-for="(item, index) in tableData.dateTitles" :key="index" width="110">
        <template #header><div>{{ item }}</div></template>
        <template #default="scope">
          <el-popover title="任务列表" placement="bottom" width="600">
            <div v-if="scope.row.dateTaskList[index].taskCount">
              <el-table :data="scope.row.dateTaskList[index].task">
                <el-table-column property="task" label="任务说明">
                  <template #default="sonScope">
                    <div style="text-align: left">{{sonScope.row.task}}</div>
                  </template>
                </el-table-column>
                <el-table-column property="address" label="完成情况" width="100">
                  <template #default="sonScope">
                    <el-switch disabled v-model="sonScope.row.state" :active-value="1" :inactive-value="0"/>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <template #reference>
              <div v-if="scope.row.dateTaskList[index].taskCount>0">
                <div>任务：{{scope.row.dateTaskList[index].taskCount}}</div>
                 <div>已完成：{{scope.row.dateTaskList[index].taskFinishCount}}</div>
              </div>
            </template>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          style="text-align: right;margin: 20px 10px"
          :page-sizes="[20, 30, 40, 50]"
          :page-size="query.pageSize"
          @current-change="handlePageChange"
          layout="total, prev, pager, next, jumper"
          :total="tableData.pageList.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import SelectArea from "../../components/SelectArea";
import {getSetPageList} from "@/api/coach";
export default {
  components: {
    SelectArea
  },
  name: "CoachNewbieTaskDetails",
  data() {
    return {
      tableData:{
        pageList:{
          records:[]
        }
      },
      query:{
        areaIdList:[],
        coachName:"",
        changeDate:null,
        startDate:null,
        endDate:null,
        loading:false,
        pageIndex: 1,
        pageSize: 10,
      },

    }
  },
  created() {
    this.selectPageList();
  },
  methods:{
    selectPageList(){
      if ( this.query.changeDate!=null && this.query.changeDate.length>0){
        this.query.startDate=this.query.changeDate[0];
        this.query.endDate=this.query.changeDate[1];
      }else {
        this.query.startDate=null;
        this.query.endDate=null;
      }
      getSetPageList(this.query).then(val=>{
        console.log(val.data)
        if (val.code == 200) {
          this.tableData = val.data
        } else {
          this.$message.error("获取城市数据失败");
        }
      })
    },
    handlePageChange(val) {
      this.query.pageIndex = val
      this.selectPageList();
    },
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  font-size: 14px;
}
</style>